import { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

const Paper = ({
  className,
  elevation = 1,
  variant = 'elevation',
  children,
  ...props
}: Props) => {
  const elevationClasses = {
    0: 'shadow-none',
    1: 'shadow-sm',
    2: 'shadow',
    3: 'shadow-lg',
  }

  return (
    <div
      className={cn(
        'bg-background rounded-lg',
        variant === 'elevation' && elevationClasses[elevation],
        variant === 'outlined' && 'border',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode | ReactNode[]
  elevation?: 0 | 1 | 2 | 3
  variant?: 'elevation' | 'outlined'
}

export default Paper
